(function () {
  'use strict';

  class FeaturedProductsCarousel extends HTMLElement {
    constructor() {
      super();
      console.log('[FeaturedProductsCarousel] 👋 Constructor called');
      this.swiperInstance = null;
    }

    connectedCallback() {
      console.log('[FeaturedProductsCarousel] 🔌 Connected to DOM');
      this.initSwiper();
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy();
        this.swiperInstance = null;
      }
    }

    initSwiper() {
      const carousel = this.querySelector('[data-carousel]');
      const slides = this.querySelectorAll('[data-carousel-slide]');

      if (!carousel || !slides.length) {
        console.log('[FeaturedProductsCarousel] ❌ Missing elements:', {
          carousel: carousel,
          slidesCount: slides.length
        });
        return;
      }

      // Get settings from data attributes
      const slidesToShow = parseInt(this.getAttribute('data-slides-to-show')) || 6;
      const slidesToScroll = parseInt(this.getAttribute('data-slides-to-scroll')) || 1;

      console.log('[FeaturedProductsCarousel] ⚙️ Config:', {
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        totalSlides: slides.length
      });

      // Initialize Swiper
      this.swiperInstance = new Swiper(carousel, {
        slidesPerView: slidesToShow,
        loop: true,
        loopedSlides: slides.length,
        loopAdditionalSlides: slidesToShow * 3,
        initialSlide: slides.length / 2,
        loopAddBlankSlides: true,
        breakpoints: {
          320: {
            slidesPerView: 1,
          },
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: Math.min(4, slidesToShow),
          },
          1280: {
            slidesPerView: slidesToShow,
          }
        },
        on: {
          init: function() {
            console.log('[Swiper] Initialized with', this.slides.length, 'slides (loop enabled)');
          }
        }
      });

      console.log('[FeaturedProductsCarousel] ✅ Swiper initialized!');
    }
  }

  // Register custom element
  if (!customElements.get('featured-products-carousel')) {
    customElements.define('featured-products-carousel', FeaturedProductsCarousel);
    console.log('[FeaturedProductsCarousel] ✅ Custom element registered!');
  }
})();

